module.exports = __webpack_public_path__ + "img/65.c4d28e1b.jpg";